import { format, isValid, parseISO } from "date-fns"

// Parse a marina-local "YYYY-MM-DD" string as local midnight. date-fns parseISO
// treats a date-only string as local time, avoiding the UTC shift of
// `new Date("YYYY-MM-DD")` (which lands on the previous day for browsers behind
// UTC). Returns null for a missing/empty/unparseable value (parseISO returns a
// truthy Invalid Date for malformed input, which a `?? fallback` would miss).
export const parseDateOnly = (iso) => {
  if (!iso) return null
  const parsed = parseISO(iso)
  return isValid(parsed) ? parsed : null
}

// Format a Date to "YYYY-MM-DD" from local parts (not toISOString, which is UTC
// and can roll the date forward/back depending on the browser's offset).
export const formatDateOnly = (date) => format(date, "yyyy-MM-dd")
